import React from 'react';
import { useNavigate } from 'react-router-dom';

const CARDS = [
  {
    title: "Products",
    description: "Configure financial products and categories",
    path: "/product-catalogue",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="2" y="3" width="7" height="7" rx="1"/><rect x="15" y="3" width="7" height="7" rx="1"/>
        <rect x="2" y="14" width="7" height="7" rx="1"/><rect x="15" y="14" width="7" height="7" rx="1"/>
      </svg>
    ),
    color: "#0184FF",
  },
  {
    title: "Locations",
    description: "Manage service cities and states",
    path: "/location",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
        <circle cx="12" cy="9" r="2.5"/>
      </svg>
    ),
    color: "#10B981",
  },
  {
    title: "Users",
    description: "Manage admin user accounts and roles",
    path: "/users",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
    color: "#8B5CF6",
  },
  {
    title: "Mobile Configurations",
    description: "Set mobile app options and settings",
    path: "/mobileconfigurations",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="7" y="2" width="10" height="20" rx="2"/>
        <line x1="12" y1="18" x2="12.01" y2="18" strokeLinecap="round" strokeWidth="2.5"/>
      </svg>
    ),
    color: "#F59E0B",
  },
  {
    title: "Notifications",
    description: "Manage alerts and notification templates",
    path: "/notifications",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
        <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
      </svg>
    ),
    color: "#EF4444",
  },
  {
    title: "Product Ordering",
    description: "Set display order of categories and products in the mobile app",
    path: "/product-ordering",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/>
        <polyline points="3 6 4 7 6 5"/><polyline points="3 12 4 13 6 11"/><polyline points="3 18 4 19 6 17"/>
      </svg>
    ),
    color: "#7C3AED",
  },
  {
    title: "Invoice",
    description: "Generate and schedule invoices",
    path: "/invoice",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <line x1="16" y1="13" x2="8" y2="13"/>
        <line x1="16" y1="17" x2="8" y2="17"/>
        <line x1="10" y1="9" x2="8" y2="9"/>
      </svg>
    ),
    color: "#06B6D4",
  },
];

const ConfigCard = ({ title, description, path, icon, color }) => {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => navigate(path)}
      className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-md hover:border-[#0184FF]/30 cursor-pointer transition-all group"
    >
      <div
        className="w-12 h-12 rounded-xl flex items-center justify-center mb-4 transition-colors"
        style={{ background: color + "15", color }}
      >
        {icon}
      </div>
      <h3 className="text-base font-semibold text-[#0F172A] mb-1 group-hover:text-[#0184FF] transition-colors">{title}</h3>
      <p className="text-sm text-[#64748B]">{description}</p>
      <div className="mt-4 flex items-center gap-1 text-xs font-medium text-[#0184FF] opacity-0 group-hover:opacity-100 transition-opacity">
        Open
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <path d="M5 12h14M12 5l7 7-7 7"/>
        </svg>
      </div>
    </div>
  );
};

const Configurations = () => (
  <div className="min-h-screen bg-[#F8FAFC] p-1">
    <div className="mb-6">
      <h1 className="text-xl font-bold text-[#0F172A]">Configurations</h1>
      <p className="text-sm text-[#64748B] mt-0.5">System settings and configuration options</p>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
      {CARDS.map((card) => (
        <ConfigCard key={card.path} {...card} />
      ))}
    </div>
  </div>
);

export default Configurations;
